import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";


const PaginationComponent = ({ pageCount, totalItems, handlePageClick }) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth < 768); // Example breakpoint
  }, []);

  const handlePageClick2 = (event) => {
    return handlePageClick(event.selected);
  };
  return (
    <div className="my-8">
      <div className="text-sm italic font-semibold">
        Total Items = {totalItems === undefined ? 0 : totalItems}
      </div>
      <div className="w-[100%] flex justify-center  items-center p-2 border-[1px] border-light-green-color dark:border-light-green-color-dark rounded-md my-2">
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next →"
          onPageChange={handlePageClick2}
          pageRangeDisplayed={isMobile ? 3 : 5}
          pageCount={pageCount}
          previousLabel="← Prev"
          renderOnZeroPageCount={null}
          className="flex space-x-3 items-center"
          pageClassName="font-bold"
          activeLinkClassName="bg-light-green-color rounded-md px-2 py-1 border-[1px] border-light-green-color dark:border-light-black-color-dark"
          previousClassName=" border-[1px] border-light-black-color dark:border-light-black-color-dark rounded-md px-2 py-1 text-sm whitespace-nowrap"
          nextClassName="border-[1px] border-light-black-color dark:border-light-black-color-dark rounded-md px-2 py-1 text-sm whitespace-nowrap"
          marginPagesDisplayed={isMobile ? 3 : 5}
        />
      </div>
    </div>
  );
};

export default PaginationComponent;
